const PageBody = ({
  body,
}) => {
  const hasBody = Array.isArray(body) && body.length > 0;

  // Don't render the section if nothing is available
  if (!hasBody) return null;

  return (
    <section onContextMenu={(e) => e.preventDefault()}>
      <div className="container mt-5">
        <div className="row justify-content-center g-4">

			
		  {/* ✅ Body Content (Rich Text) */}
          {hasBody &&
            body.map((block, index) =>
              block.type === "paragraph" ? (
                <div className="col-12" key={index}>
                  <p className="lead display-6 text-dark mb-0 mt-0" style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                    {block.children?.map((child, i) => (
                      <span key={i}>{child.text}</span>
                    ))}
                  </p>
                </div>
              ) : null
            )}
        </div>
      </div>
    </section>
  );
};

export default PageBody;

